import { Button, CardContent, TextField } from '@material-ui/core';
import FancyCard from '../../../components/fancy/FancyCard';
import React, { useEffect, useState } from 'react';
import { useSwaggerClient } from '../../../hooks/useSwaggerClient';
import { formatMoney } from '../../../utils';
import { Alert } from '@material-ui/lab';
import FillBalanceForm from '../../../components/balance/FillBalanceForm';

function PaymentFormBalance({
    method,
    note,
    setNote,
    guestId,
    hasEnoughBalance,
    setHasEnoughBalance,
    estimatedTotal
}) {
    const [showBalanceFillForm, setShowBalanceFillForm] = useState(false);
    // we should get the balance for the user, so we can do a simple check: is it enough
    const [
        balancesData,
        balancesLoading,
        balancesError,
        _setBalance,
        reloadBalance
    ] = useSwaggerClient('balance', 'getBalance', { userId: guestId });
    const balance = balancesData?.balances?.find(e => e.slug === method?.slug);

    useEffect(() => {
        if (!balance || estimatedTotal === false) {
            setHasEnoughBalance(false);
            return;
        }
        if (balance.amount >= estimatedTotal) {
            setHasEnoughBalance(true);
        } else {
            setHasEnoughBalance(false);
        }
    }, [balance, estimatedTotal, setHasEnoughBalance]);

    if (balancesLoading) {
        return null;
    }
    if (balancesError || !balance) {
        return <FancyCard fullWidth>Error loading balance</FancyCard>;
    }

    return (
        <FancyCard fullWidth>
            <CardContent>
                <h3 className="mb-2">Pay by Balance</h3>
                <p>Your current balance is {formatMoney(balance.amount)}</p>
                {!hasEnoughBalance && (
                    <>
                        <Alert severity="warning">
                            <h4>Insufficient balance for this payment.</h4>
                            <p>The payment can be done, but the liability is on the agent.</p>
                            <Button
                                variant="contained"
                                className="mt-2 mb-4"
                                color="primary"
                                onClick={() => setShowBalanceFillForm(!showBalanceFillForm)}
                            >
                                {showBalanceFillForm ? 'Settle later' : 'Fill Balance now'}
                            </Button>
                        </Alert>
                        {showBalanceFillForm && (
                            <FillBalanceForm
                                balanceSlug={balance.slug}
                                amountHint={estimatedTotal ? estimatedTotal - balance.amount : 0}
                                onBalanceChange={() => {
                                    reloadBalance();
                                }}
                            />
                        )}
                    </>
                )}
                <TextField
                    fullWidth
                    label="Note for the balance payment"
                    name="cashnote"
                    placeholder="Note is required to identify the check itself."
                    type="text"
                    value={note}
                    onChange={ev => {
                        setNote(ev.target.value);
                    }}
                />
            </CardContent>
        </FancyCard>
    );
}

export default PaymentFormBalance;
